<mat-sidenav-container class="main-container">
  <mat-sidenav #drawer id="drawer">
    <app-menu-drawer
      [drawerRef]="drawer"
      [routesData]="routeData()"
    ></app-menu-drawer>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <app-toolbar [drawerSideNav]="drawer"></app-toolbar>
    <div class="router-container">
      <router-outlet />
    </div>
    <custom-footer2></custom-footer2>
  </mat-sidenav-content>
</mat-sidenav-container>
